module.exports = __webpack_public_path__ + "static/img/i45.2c5dc81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images1/i45.png
// module id = 3j4R
// module chunks = 3